import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { api__createOrder, api__getOrderDetailsByParams, api__getOrderWithPaymentInfo, api__getPromoCode } from "@/apis/orders/orders";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import useHelpers from "@hooks/useHelpers";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { normalizeIdNumber } from "@/utils/stringHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
var extractQueryParams = function extractQueryParams() {
  var _searchParams$get, _searchParams$get2;
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var post_id = Number(searchParams.get('post_id'));
  var order_id = normalizeIdNumber(searchParams.get("id"));
  if (!order_id) {
    order_id = normalizeIdNumber(searchParams.get("order_id"));
  }
  var is_test_order = ((_searchParams$get = searchParams.get("id")) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.includes("test")) || ((_searchParams$get2 = searchParams.get("order_id")) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.includes("test"));
  var customerid = searchParams.get('customerid');
  var referral = searchParams.get('referral');
  var hasTawuniyaParams = customerid && referral;
  return {
    order_id: order_id,
    post_id: post_id,
    is_test_order: is_test_order,
    hasTawuniyaParams: hasTawuniyaParams,
    customerid: customerid,
    referral: referral
  };
};
var getFormDataDefault = function getFormDataDefault(user, checkoutOrder) {
  return {
    full_name: (user === null || user === void 0 ? void 0 : user.full_name) || "",
    city_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.city_id) || null,
    phone_number: (user === null || user === void 0 ? void 0 : user.phone_number) || "",
    whatsapp_optin: 1,
    code: null
  };
};
var CheckoutOrderContext = /*#__PURE__*/createContext(null);
export function useCheckoutOrder() {
  return useContext(CheckoutOrderContext);
}
export default function CheckoutOrderContextProvider(_ref) {
  var children = _ref.children;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(extractQueryParams()),
    queryParams = _useState[0],
    setQueryParams = _useState[1];
  var _useState2 = useState(),
    referralData = _useState2[0],
    setReferralData = _useState2[1];
  var _useState3 = useState(),
    checkoutOrder = _useState3[0],
    setCheckoutOrder = _useState3[1];
  var _useState4 = useState(false),
    fetch_loading = _useState4[0],
    setFetch_loading = _useState4[1];
  var _useState5 = useState(null),
    fetching_error = _useState5[0],
    setFetching_error = _useState5[1];
  var _useState6 = useState(null),
    formValidationException = _useState6[0],
    setFormValidationException = _useState6[1];
  var _useState7 = useState(getFormDataDefault(user)),
    formData = _useState7[0],
    setFormData = _useState7[1];
  var action__initFormData = function action__initFormData() {
    setQueryParams(extractQueryParams());
    setFormData(getFormDataDefault(user, checkoutOrder));
    setReferralData(null);
    setFormValidationException(null);
    setFetching_error(null);
  };
  useEffect(function () {
    if (queryParams !== null && queryParams !== void 0 && queryParams.post_id) {
      fetch__getOrderDetailsByParams({
        code: formData.code
      }).then(console.log);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.city_id, queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id]);
  useEffect(function () {
    setQueryParams(extractQueryParams());
  }, [location]);
  var setFormItem = function setFormItem(key, value) {
    setFormData(_objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, key, value)));
  };
  var action__resetPromoCode = function action__resetPromoCode() {
    setFormItem('code', null);
    setReferralData(null);
    fetch__getOrderDetailsByParams({
      code: null
    });
  };
  var fetch__getOrderDetailsByParams = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var override,
        params,
        order,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            override = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, queryParams), !referralData || !referralData.valid ? {
              code: ''
            } : {}), formData), {}, {
              post_id: queryParams.post_id
            }, override);
            setFetch_loading(true);
            _context.prev = 3;
            _context.next = 6;
            return api__getOrderDetailsByParams(params);
          case 6:
            order = _context.sent;
            setCheckoutOrder(order);
          case 8:
            _context.prev = 8;
            setFetch_loading(false);
            return _context.finish(8);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3,, 8, 11]]);
    }));
    return function fetch__getOrderDetailsByParams() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetch__getOrderWithPaymentInfo = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(post_id, order_id) {
      var order;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setFetch_loading(true);
            _context2.next = 4;
            return api__getOrderWithPaymentInfo(user === null || user === void 0 ? void 0 : user.id, order_id, post_id);
          case 4:
            order = _context2.sent;
            setCheckoutOrder(order);
            _context2.next = 13;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            if (!(_context2.t0 instanceof ReservedPostException)) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return", navigateTo("/cardetail/".concat(_context2.t0.post_id, "?ref=car_reserved")));
          case 12:
            setFetching_error(_context2.t0);
          case 13:
            _context2.prev = 13;
            setFetch_loading(false);
            return _context2.finish(13);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8, 13, 16]]);
    }));
    return function fetch__getOrderWithPaymentInfo(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetch__getPromoCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(code) {
      var promData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setFetch_loading(true);
            _context3.next = 4;
            return api__getPromoCode({
              code: code,
              post_id: queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id,
              city_id: (formData === null || formData === void 0 ? void 0 : formData.city_id) || null
            });
          case 4:
            promData = _context3.sent;
            setReferralData(promData);
            return _context3.abrupt("return", promData);
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            setFetching_error(_context3.t0);
          case 12:
            _context3.prev = 12;
            setFetch_loading(false);
            return _context3.finish(12);
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 9, 12, 15]]);
    }));
    return function fetch__getPromoCode(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var fetch__createOrder = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var toBeSendParams, newOrder;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            toBeSendParams = _objectSpread(_objectSpread(_objectSpread({}, queryParams), formData), {}, {
              examine_date: ''
            });
            delete toBeSendParams["code"];
            if (referralData && referralData.valid) {
              toBeSendParams["referral_code_id"] = referralData.referral_code_id;
            }
            dispatchButtonLoading(true);
            _context4.prev = 4;
            _context4.next = 7;
            return api__createOrder(toBeSendParams);
          case 7:
            newOrder = _context4.sent;
            setCheckoutOrder(newOrder);
            return _context4.abrupt("return", newOrder);
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](4);
            if (!(_context4.t0 instanceof ValidationException)) {
              _context4.next = 16;
              break;
            }
            return _context4.abrupt("return", setFormValidationException(_context4.t0));
          case 16:
            console.log('error', _context4.t0);
            toast.error(_context4.t0.message);
            throw _context4.t0;
          case 19:
            _context4.prev = 19;
            dispatchButtonLoading(false);
            return _context4.finish(19);
          case 22:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[4, 12, 19, 22]]);
    }));
    return function fetch__createOrder() {
      return _ref5.apply(this, arguments);
    };
  }();

  /** Collections **/
  var actions = {
    setCheckoutOrder: setCheckoutOrder,
    setFormItem: setFormItem,
    action__resetPromoCode: action__resetPromoCode,
    action__initFormData: action__initFormData
  };
  var remote_actions = {
    fetch__getOrderWithPaymentInfo: fetch__getOrderWithPaymentInfo,
    fetch__getOrderDetailsByParams: fetch__getOrderDetailsByParams,
    fetch__getPromoCode: fetch__getPromoCode,
    fetch__createOrder: fetch__createOrder
  };
  var state = {
    checkoutOrder: checkoutOrder,
    fetch_loading: fetch_loading,
    fetching_error: fetching_error,
    formData: formData,
    referralData: referralData,
    formValidationException: formValidationException
  };
  return /*#__PURE__*/React.createElement(CheckoutOrderContext.Provider, {
    value: {
      actions: actions,
      remote_actions: remote_actions,
      state: state,
      queryParams: queryParams
    }
  }, children);
}